import React from 'react'
import {Link} from 'gatsby'
import Video from '../Video'
import {Header, Image} from 'semantic-ui-react'
import * as styles from './styles/pagesection.module.css'
import ImageHolder from '../ImageHolder'

const PageSectionComponent = ({sectionList, pageName}) =>  {
	const createLinkContent = ({internalLink,externalLink, content}) => {

		// Handle Links, if any
		if(internalLink!== undefined) {
			if (internalLink !==null) {
				return <Link to={internalLink}>
							{content}
						</Link>
			}
		}
		if(externalLink!== undefined) {
			if (externalLink !==null) {
				return <a
							href={externalLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							{content}
						</a>
			}
		}

		return content
	}

	const mapSectionList = ({type, title, content, items, internalLink, externalLink, imgurl, imgHeightToWidthRatio, mobileimgHeightToWidthRatio, mobileurl}, depth=0)=> {

		let titleClassName = depth===0 ? styles.header:`${styles.header} ${styles.noMargin}`;
		let titleContent = (
			<React.Fragment>
				{title && <Header className={titleClassName}>{title}</Header> }
			</React.Fragment>
		);
		let preSectionContent = null;
		let sectionContent = null;

		//just in case type wasn't properly assigned a value
		if(type===undefined || type===null) {
			return ""
		}

		if(type==="html") {
			// remove titleContent?
			preSectionContent = titleContent;
			sectionContent = (
				<div
					className={styles.text}
					dangerouslySetInnerHTML={{
						__html: content
					}}
				/>
			)
		}else if(type==="text") {
			preSectionContent = titleContent;
			sectionContent = <React.Fragment>
				{content.split("\n").map((data, index) => {
					if (data === "") return <></>
					return <p className={styles.text}>
						{createLinkContent({internalLink, externalLink, content: data})}
					</p>
				})}
			</React.Fragment>
		}else if(type==="image-full") {
			// If imgHeightToWidthRatio is set, use ImageHolder component. Otherwise just use normal Image component
			if (mobileurl !== undefined) {
				sectionContent = createLinkContent({internalLink, externalLink, content:
				imgHeightToWidthRatio !== undefined ? <>
					<ImageHolder heightToWidthRatio={imgHeightToWidthRatio} imageHolderClassname={styles.fullBlockDesktopOnly} src={imgurl} alt={title} fluid/>
					<ImageHolder heightToWidthRatio={mobileimgHeightToWidthRatio} imageHolderClassname={styles.fullBlockMobileOnly} src={mobileurl} alt={title} fluid/>
				</> : <>
					<Image className={styles.fullBlockDesktopOnly} src={imgurl} alt={title} fluid/>
					<Image className={styles.fullBlockMobileOnly} src={mobileurl} alt={title} fluid/>
				</>})
			} else {
				sectionContent = createLinkContent({internalLink, externalLink, content:
					imgHeightToWidthRatio !== undefined
					? <ImageHolder heightToWidthRatio={imgHeightToWidthRatio} imageHolderClassname={styles.fullBlock} src={imgurl} alt={title} fluid/>
					: <Image className={styles.fullBlock} src={imgurl} alt={title} fluid/>
				})
			}
		}else if(type==="specification") {
			sectionContent = (<div className={styles.text}>
								<strong>{title}</strong>:
								{createLinkContent({internalLink, externalLink, content})}
							</div>)
		} else if(type.split("-")[0]==="list") {
			let listContent = (
				<React.Fragment>
					{items.map((section, innerIndex)=>{
						if(depth===4 && section.type.split("-")[0]==="list" ) {
							return "";
						}
						return (
							<li key={`${section.type}-${section.content}-${section.title}-${section.imgurl}-depth${depth+1}`} className={styles.listMargin}>{mapSectionList(section, depth+1)}</li>
						)
					})}
				</React.Fragment>
			)
			if(type.split("-")[1]==="numbered") {
				sectionContent = (
					<ol>
						{listContent}
					</ol>
				)
			}else if(type.split("-")[1]==="bullet") {
				sectionContent = (
					<ul>
						{listContent}
					</ul>
				)
			}
			preSectionContent = (
				<React.Fragment>
					{titleContent}
					<div className={styles.text}>
						{createLinkContent({internalLink, externalLink, content})}
					</div>
				</React.Fragment>
			)
		} else if (type === "video-embedurl") {
			sectionContent = <div>
				<React.Fragment key={externalLink} itemscope="" itemprop="VideoObject" itemtype="https://schema.org/VideoObject">
					<Video src={externalLink} title={content} size={"wide"}/>
				</React.Fragment>
			</div>
		}
		return (
			<React.Fragment>
				{preSectionContent}
				{sectionContent}
			</React.Fragment>
		)
	} // mapSectionList

	return (
		<div>
			{sectionList.map((section, index)=>{
				if(section.content===pageName) {
					return ""
				}
				return (
					<div className={styles.sectionMargin} key={`${section.type}-${section.content}-${section.title}-${section.imgurl}-depth0`}>
						{mapSectionList(section, 0)}
					</div>
				)
			})}
		</div>
	)
}

export default PageSectionComponent
